/**
 * Layout Storage Service
 *
 * The custom portal layout lives on the workflow definition itself, delivered
 * by GetWorkflowDefinition as a stringified JSON blob under `portalLayout`.
 * UpdateWorkflowDefinition persists it the same way. This module is now just a
 * parser for the API-provided value.
 */

import { PortalLayout } from './layoutSchema.types';

/**
 * Parse a portal layout from a workflow definition API response. The backend
 * stores the layout as a stringified JSON blob under `portalLayout`. Returns
 * null when the workflow has no custom layout configured or the payload can't
 * be parsed against the current schema.
 */
export function loadLayoutFromDefinition(workflowDefinition: any): PortalLayout | null {
	if (!workflowDefinition?.portalLayout) return null;

	try {
		const raw = typeof workflowDefinition.portalLayout === 'string'
			? workflowDefinition.portalLayout
			: JSON.stringify(workflowDefinition.portalLayout);
		const parsed = JSON.parse(raw) as PortalLayout;

		if (parsed.version === 1) {
			return parsed;
		}
	} catch (e) {
		console.error('Failed to parse portalLayout from workflow definition:', e);
	}
	return null;
}
